import React, { useState, useRef } from "react"
import PropTypes from "prop-types"
import { useIntl } from "gatsby-plugin-intl"

import postForm from "utils/postForm"
import useWindowSize from "utils/useWindowSize"

import ContactForm from "components/molecules/ContactForm"
import P from "components/atoms/P"
import H from "components/atoms/H"

import Industrial from "assets/images/industrial.svg"
import theme from "styles/theme"

import {
  StyledContactWrapper,
  StyledTextWrapper,
  textStyles,
  StyledFormWrapper,
  titleStyles,
  StyledImageWrapper,
} from "./ContactSection.styles"

const ContactSection = ({ trackingOptions }) => {
  const [responseStatus, setResponseStatus] = useState(false)
  const [phoneError, setPhoneError] = useState(null)
  const inputEl = useRef(null)
  const { formatMessage } = useIntl()
  const size = useWindowSize()

  const sendForm = async (formData) => {
    const response = await postForm(formData)

    setResponseStatus(
      response.data.sendContactMessage && response.data.sendContactMessage.ok
    )

    if (inputEl.current && response.data.sendContactMessage.ok) {
      inputEl.current.scrollIntoView({ behavior: "smooth" })
    }

    const { errors } = response
    setPhoneError(
      errors && errors[0].extensions.validationErrors[0].phoneNumber
    )
  }

  return (
    <>
      <StyledContactWrapper
        id="contact"
        ref={inputEl}
        data-testid="contactSectionWrapper"
      >
        {responseStatus ? (
          <StyledTextWrapper center data-testid="contactSectionSuccessWrapper">
            <H
              as="h2"
              extraStyles={titleStyles}
              data-testid="contactSectionSuccessTitle"
            >
              {formatMessage({ id: "contactForm.success.title" })}
            </H>
            <P
              extraStyles={textStyles}
              data-testid="contactSectionSuccessParagraph"
            >
              {formatMessage({ id: "contactForm.success.message" })}
            </P>
          </StyledTextWrapper>
        ) : (
          <StyledFormWrapper>
            <StyledTextWrapper data-testid="contactSectionTextWrapper">
              <H
                as="h2"
                extraStyles={titleStyles}
                data-testid="contactSectionTextTitle"
              >
                {formatMessage({ id: "contactForm.contactSection.title" })}
              </H>
              <P
                extraStyles={textStyles}
                data-testid="contactSectionTextParagraph"
              >
                {formatMessage({
                  id: "contactForm.contactSection.description",
                })}
              </P>
              {size.width >= theme.breakpoints.medium && (
                <StyledImageWrapper>
                  <Industrial />
                </StyledImageWrapper>
              )}
            </StyledTextWrapper>
            <ContactForm
              sendForm={sendForm}
              phoneError={phoneError}
              trackingOptions={trackingOptions}
            />
          </StyledFormWrapper>
        )}
      </StyledContactWrapper>
    </>
  )
}

ContactSection.propTypes = {
  trackingOptions: PropTypes.shape(),
}

ContactSection.defaultProps = {
  trackingOptions: null,
}

export default ContactSection
